import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfig } from 'src/app/configs/app.config';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonService, PasswordErrorStateMatcher } from 'src/app/core/services/common.service';

import { InformationBoxComponent } from 'src/app/shared/information-box/information-box.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  password: string = "";
  cnfrmPassword: string = "";
  hidePassword: boolean = false;
  hideCnfrmPassword: boolean = false;
  isValid: boolean = false;
  token;
  readonly siteLogo: string;
  loading: boolean = false;

  passwordMatchError: boolean = false;
  minPasswordLengthError: boolean = false;
  maxPasswordLengthError: boolean = false;
  passwordForm: UntypedFormGroup;
  matcher = new PasswordErrorStateMatcher();

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private commonService: CommonService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {
    this.siteLogo = AppConfig.SITE_LOGO
    this.passwordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(20), this.commonService.passwordValidation()]],
      confirmPassword: ['', [Validators.required]],
    }, { validator: this.checkPasswords });
  }

  ngOnInit(): void {
    this.validate();
    this.spinner.show();
  }

  checkPasswords(group: UntypedFormGroup) { // here we have the 'passwords' group
    let pass = group.controls.password.value;
    let confirmPass = group.controls.confirmPassword.value;

    return pass === confirmPass ? null : { notSame: true }
  }

  validate() {
    this.isValid = true;
    if (this.password == '') {
      this.isValid = false;
    }
    if (this.cnfrmPassword == '') {
      this.isValid = false;
    }
    if ((this.password.length != 0 && this.cnfrmPassword.length != 0) && this.password != this.cnfrmPassword) {
      this.passwordMatchError = true;
      this.isValid = false;
    }
    else {
      this.passwordMatchError = false;
    }
    if (this.password.length != 0 && this.password.length < 8) {
      this.isValid = false;
      this.minPasswordLengthError = true;
    }
    else this.minPasswordLengthError = false;
    if (this.password.length != 0 && this.password.length > 20) {
      this.isValid = false;
      this.maxPasswordLengthError = true;
    }
    else this.maxPasswordLengthError = false;
  }

  updatePasswordRequest() {
    // console.log((this.updatePasswordRequestForm.get('password').value == ''))
    // if (this.updatePasswordRequestForm.get('password').value == '') {
    //   this.newpasswd = true;
    //   return;
    // }
    // if (this.updatePasswordRequestForm.get('cnfmPassword').value == '') {
    //   this.newcnfrmpasswd = true;
    //   return;
    // }
    // this.disableButton = true;
    // console.log(this.updatePasswordRequestForm.value)
    this.token = this.activatedRoute.snapshot.queryParamMap.get("token");
    this.authService.passwordValidate({ token: this.token }).subscribe(res => {
      if (res.status == 'OK') {
        this.loading = true
        this.authService.passwordReset(this.token, { password: this.password }).subscribe(res => {
          this.spinner.show();
          this.loading = false;
        },(err) => {
          this.loading = false;
        },
        ()=>{
          let dialogRef = this.dialog.open(InformationBoxComponent, {
            width: '38em',
            autoFocus: false,
            data: {type:'passwordComponent'},
            panelClass: 'information-modalbox',
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            // this.AllIOs = result.allInsertionOrders.filter(
            //   (ele) => ele.id != result.selectedInsertion.id
            // );
            // this.AllIOs.push(result.selectedInsertion);
            this.router.navigate(['/signin']);
          });
        })
      }
    }, (err) => {
      this.loading = false;
    })
    // this.userService.changeUserPasswordRequest(this.changePasswordRequestForm.value).subscribe(res => {
    //   this.changePasswordRequestForm.reset();
    //   console.log(res)
    //   // if (res.Success) {
    //   //   this.passwordChangeMessage = res.Success;
    //   //   this.passwordChangeMessagebool = true;
    //   //   this.passwdChangeError = false;
    //   // }
    // }, err => {
    //   console.log(err)
    //   this.changePasswordRequestForm.reset();
    //   this.disableButton = false;
    // });
  }

}
